import SpecialEventsData from "../../components/hotel/datamanagement/SpecialEventsData";

export default function SpecialEventsPage() {
  return <SpecialEventsData />;
}

